import _ from 'lodash';
import { takeLatest, put, call, select, all } from 'redux-saga/effects';

import { DisplayContainer, Experience } from 'common-entities';
import RefData from 'ref-data';

import Api from './display-container-api';
import Actions from './display-container-actions';

function* fetchWithEmbedCodesHandler({ payload: { channelId, status } }) {
  try {
    const displayContainers = yield call(Api.fetchContainersWithEmbedCodes, channelId, { status });
    yield put(Actions.fetchWithEmbedCodesSuccess(displayContainers));
  } catch (error) {
    yield put(Actions.fetchWithEmbedCodesFailure(error));
  }
}

function* deleteContainerHandler({ payload: { containerId } }) {
  const _delete = yield call(Api.deleteContainer, containerId);

  if (_delete.error) yield put(Actions.deleteContainerFailure(_delete.error.rawResponse));
  else yield put(Actions.deleteContainerSuccess(containerId));
}

function* publishContainerHandler({ payload: { containerId } }) {
  const _publishedContainer = yield call(Api.publishContainer, containerId);
  if (_publishedContainer.error) yield put(Actions.publishContainerFailure(_publishedContainer.error));
  else yield put(Actions.publishContainerSuccess(_publishedContainer));
}

function* expireContainerHandler({ payload: { containerId } }) {
  const _expiredContainer = yield call(Api.expireContainer, containerId);

  if (_expiredContainer.error) yield put(Actions.expireContainerFailure(_expiredContainer.error));
  else yield put(Actions.expireContainerSuccess(_expiredContainer));
}

// Set container as default.
function* setDefaultHandler({ payload: { containerId } }) {
  const _container = yield call(Api.setDefault, containerId);
  if (!!_container.error) yield put(Actions.setDefaultFailure(_container.error));
  else yield put(Actions.setDefaultSuccess(_container));
}

// Set container as root.
function* setRootHandler({ payload: { containerId } }) {
  const _container = yield call(Api.setRoot, containerId);
  if (!!_container.error) yield put(Actions.setRootFailure(_container.error));
  else yield put(Actions.setRootSuccess(_container));
}

//fetch the third party code
function* tryFetchThirdPartyProviderCode() {
  const experience = yield select(Experience.Selectors.experience);
  const formatType = _.get(experience, ['formatType', 'id'], '') || RefData.Enum.FORMAT.DISPLAY.MICRO;
  const thirdPartyProvider = yield select(DisplayContainer.Selectors.thirdPartyProvider);
  if (
    !thirdPartyProvider.hasFetched || //data never fetched OR
    thirdPartyProvider.formatType !== formatType //formatType of data not the same as experience formatType
  ) {
    yield put(Actions.fetchThirdPartyProviderCode());

    const thirdPartyProviderCode = yield call(Api.fetchThirdPartyProviderCode, { formatType });
    if (thirdPartyProviderCode.error) {
      yield put(Actions.fetchThirdPartyProviderCodeFailure(thirdPartyProviderCode.error));
    } else {
      yield put(Actions.fetchThirdPartyProviderCodeSuccess(thirdPartyProviderCode, formatType));
    }
  }
}

function* saveVanityPathHandler() {
  let vanityPath = yield select(DisplayContainer.Selectors.vanityPath);
  const containerId = yield select(DisplayContainer.Selectors.vanityPathContainerId);
  // Ensure vanityPath starts with a slash (UI allows user to enter with or without leading slash, but API requires it)
  if (vanityPath && !vanityPath.startsWith('/')) {
    vanityPath = '/' + vanityPath;
  }
  const response = yield call(Api.setVanityPath, containerId, vanityPath);
  if (response.error) {
    yield put(Actions.saveVanityPathFailure(response.error.rawResponse));
  } else {
    yield put(Actions.saveVanityPathSuccess(response));
  }
}

export default function* displayContainerSagas() {
  yield all([
    takeLatest(Actions.fetchWithEmbedCodes.getType(), fetchWithEmbedCodesHandler),
    takeLatest(Actions.deleteContainer.getType(), deleteContainerHandler),
    takeLatest(Actions.expireContainer.getType(), expireContainerHandler),
    takeLatest(Actions.publishContainer.getType(), publishContainerHandler),
    takeLatest(Actions.setDefault.getType(), setDefaultHandler),
    takeLatest(Actions.setRoot.getType(), setRootHandler),
    takeLatest(Actions.tryFetchThirdPartyProviderCode.getType(), tryFetchThirdPartyProviderCode),
    takeLatest(Actions.saveVanityPath.getType(), saveVanityPathHandler),
  ]);
}
